import { jsx } from "react/jsx-runtime";
import { cloneElement, isValidElement } from "react";
import { cn } from "../../../utils/index.js";
const Fade = ({ children, className, style, asChild, isVisible, fadeInClass, fadeOutClass })=>{
    const cssClasses = cn(isVisible ? fadeInClass : fadeOutClass, !isVisible && 'opacity-0', className);
    if (asChild && /*#__PURE__*/ isValidElement(children)) {
        const child = children;
        const mergedClassName = cn(cssClasses, child.props.className);
        const mergedStyle = style || child.props.style ? {
            ...child.props.style,
            ...style
        } : void 0;
        return /*#__PURE__*/ cloneElement(child, {
            className: mergedClassName,
            style: mergedStyle,
            'data-testid': child.props['data-testid'] ?? 'fade-content'
        });
    }
    return /*#__PURE__*/ jsx("div", {
        className: cssClasses,
        "data-testid": "fade-content",
        style: style,
        children: children
    });
};
export { Fade };
